import { useState, useEffect } from 'react';

export interface BreakdownEntry {
    codeType: string;
    answerId: number;
    rubricPoints: number;
    category: string;
    displayText: string | null;
    codeValue: string | null;
    isOriginal: boolean | null;
}

export interface ScoringEventDto {
    id: number;
    score: number;
    acceptable: boolean;
    threshold: number;
    overallCategory: string;
    breakdown: BreakdownEntry[];
    scoringConfigId: number;
    computedAt: string;
    triggeredBy: string | null;
    computedForUserId: string | null;
}

export function useScoringEvents(sdCaseId: string | undefined): {
    events: ScoringEventDto[];
    loading: boolean;
} {
    const [events, setEvents] = useState<ScoringEventDto[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!sdCaseId) return;
        setLoading(true);
        fetch(`/api/cqa-service/v1/grader-workitem/${encodeURIComponent(sdCaseId)}/scoring-events`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `${sessionStorage.getItem('authToken')}`,
            },
        })
            .then(r => {
                if (!r.ok) return [];
                return r.json();
            })
            .then((data: ScoringEventDto[]) => setEvents(data))
            .catch(() => setEvents([]))
            .finally(() => setLoading(false));
    }, [sdCaseId]);

    return { events, loading };
}
